import React from "react"
import { AddIcon } from "."

export default {
  title: "Icons",
}

export const icons = () => <AddIcon boxSize="40px" />
